// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/index." + {"132":"b230e6599e0becc80963","162":"9f1f1912b2d7e900fc93","369":"5ce9bd996b6699ef2490","397":"b423b3f88757c40e190f","791":"658fba17bdcb7b8a4a15","866":"b55114a3c1a1692b018f","927":"d9a1493b0785c74a91fe","989":"93986954efb0e4034412"}[chunkId] + ".js";
};